// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

h1 {
  color: #888;
}

.clearfix {
  clear: both;
}

h3 {
  text-align: center;
}

.list ul li {
  display: inline-block;
}

.list ul {
  list-style: none;
  text-align: center;
}

.report-users-list {
  color: #6ABD45;
  padding-left: 0px;
  font-family: "Conv_museo-500-webfont";
  font-size: 15px;
  line-height: 1em;
}

.group-profile {
  position: relative;
  width: 100%;
  flex: 1;
}
.group-profile .inner-group-profile {
  border: 1px solid #ccc;
  border-bottom: none;
}
.group-profile .inner-group-profile .row {
  margin: 0;
  height: 50px;
  border-bottom: 1px solid #ccc;
  padding: 0;
}
.group-profile .inner-group-profile .row .text-center {
  line-height: 50px;
  margin: 0;
}
.group-profile .main-group-profile {
  position: absolute;
  top: 0;
  left: 0;
  height: 550px;
  width: 100%;
}
.group-profile .main-group-profile .common-profile {
  width: 20% !important;
  margin-left: 2.5%;
  margin-right: 2.5%;
  background-color: #ccc;
  height: 100px;
  float: left;
  max-height: 200px;
}
.group-profile .main-group-profile .high-clarify {
  background-color: rgb(0, 173, 208) !important;
}
.group-profile .main-group-profile .low-clarify {
  background-color: rgb(0, 173, 208) !important;
}
.group-profile .main-group-profile .high-ideate {
  background-color: rgb(255, 121, 0) !important;
}
.group-profile .main-group-profile .low-ideate {
  background-color: rgb(255, 121, 0) !important;
}
.group-profile .main-group-profile .high-develop {
  background-color: rgb(105, 190, 40) !important;
}
.group-profile .main-group-profile .low-develop {
  background-color: rgb(105, 190, 40) !important;
}
.group-profile .main-group-profile .high-implement {
  background-color: rgb(245, 67, 89) !important;
}
.group-profile .main-group-profile .low-implement {
  background-color: rgb(245, 67, 89) !important;
}
.group-profile .main-group-profile .profile-flex-top {
  position: absolute;
  width: 100%;
  top: 50px;
}
.group-profile .main-group-profile .profile-flex-top .common-high {
  position: relative;
}
.group-profile .main-group-profile .profile-flex-top .common-high .top-label-scores {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.group-profile .main-group-profile .profile-flex-top .common-high h5 {
  color: #fff;
  text-shadow: 0px 0px 3px #000;
}
.group-profile .main-group-profile .profile-flex-top .common-profile {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}
.group-profile .main-group-profile .profile-flex-bottom {
  position: absolute;
  top: 50%;
  margin-top: 25px;
  width: 100%;
}
.group-profile .main-group-profile .profile-flex-bottom .common-low {
  margin-bottom: 1px;
}
.group-profile .main-group-profile .profile-flex-bottom .common-low h5 {
  color: #fff;
  margin-top: 11px;
  text-shadow: 0px 0px 3px #000;
}
.group-profile .main-group-profile .profile-flex-bottom .common-profile {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}
.group-profile .main-group-profile .integrators-region {
  position: relative;
  height: 50px;
  top: 50%;
  margin-top: -25px;
  background-color: #e3e3e3 !important;
  color: #fff;
}
.group-profile .main-group-profile .integrators-region h4 {
  line-height: 50px;
  margin: 0px 15px;
}
.group-profile .bottom-labels {
  position: relative;
  margin-top: -2px;
}
.group-profile .bottom-labels .common-label {
  float: left;
  width: 20%;
  margin-left: 2.5%;
  margin-right: 2.5%;
  text-align: center;
  color: #fff;
  position: relative;
  text-transform: uppercase;
  line-height: 30px;
  height: 30px;
  text-align: center;
}
.group-profile .bottom-labels .common-label div {
  display: inline-block;
  float: none;
  width: 100%;
  --topClip: 12px;
  --labelPad: 8px;
  clip-path: polygon(0 var(--topClip), 50% 0, 100% var(--topClip), 100% 100%, 0 100%);
  padding-top: 20px;
}
.group-profile .bottom-labels .common-label div .visible-xxs {
  display: none;
}
@media only screen and (min-width: 769px) and (max-width: 910px) {
  body.dash-admin-3 .group-profile .bottom-labels .common-label div {
    min-width: 92px;
    max-width: 92px;
  }
  body.mini-navbar .group-profile .bottom-labels .common-label div {
    min-width: inherit;
    max-width: inherit;
  }
}
@media only screen and (max-width: 735px) {
  .group-profile .bottom-labels .common-label div {
    font-size: 13px;
    min-width: 85px;
    max-width: 85px;
  }
}
@media only screen and (max-width: 599px) {
  .group-profile .bottom-labels .common-label div {
    min-width: 55px;
    max-width: 55px;
  }
  .group-profile .bottom-labels .common-label div .visible-xxs {
    display: block;
  }
  .group-profile .bottom-labels .common-label div .visible-xxs + span {
    display: none;
  }
}
.group-profile .bottom-labels .clarify-block {
  background-color: rgb(0, 173, 208) !important;
}
.group-profile .bottom-labels .clarify-label:before {
  border-bottom: 12px solid rgb(0, 173, 208);
}
.group-profile .bottom-labels .ideate-block {
  background-color: rgb(255, 121, 0) !important;
}
.group-profile .bottom-labels .ideate-label:before {
  border-bottom: 12px solid rgb(255, 121, 0);
}
.group-profile .bottom-labels .develop-block {
  background-color: rgb(105, 190, 40) !important;
}
.group-profile .bottom-labels .develop-label:before {
  border-bottom: 12px solid rgb(105, 190, 40);
}
.group-profile .bottom-labels .implement-block {
  background-color: rgb(245, 67, 89) !important;
}
.group-profile .bottom-labels .implement-label:before {
  border-bottom: 12px solid rgb(245, 67, 89);
}

.participants .participant-content .col-md-2,
.participants .participant-content .col-md-1 {
  border: 0;
}
.participants .participant-content .integrator-space > div:first-child {
  background: #e3e3e3;
  font-weight: bold;
}
.participants .participant-content .integrator-space > div {
  border-right: 1px solid #aaa !important;
}
.participants .participant-content .integrator-space > div:last-child {
  border-right: 0 !important;
}
.participants .participant-content .header-part {
  border-top: 1px solid #aaa;
  border-left: 1px solid #aaa;
}
.participants .participant-content .header-part > div:first-child h3 {
  border-bottom: 0;
}
.participants .participant-content .header-part > div:first-child h3 + div {
  height: 100%;
}
.participants .participant-content .header-part > div {
  border-right: 1px solid #aaa !important;
  border-bottom: 1px solid #aaa !important;
}
.participants .participant-content .header-part > div.clearfix {
  border: 0 !important;
}
.participants .participant-content .footer-part {
  border-top: 1px solid #aaa;
  border-left: 1px solid #aaa;
}
.participants .participant-content .footer-part > div {
  border-right: 1px solid #aaa !important;
  border-bottom: 1px solid #aaa !important;
}
.participants .participant-content .footer-part > div.clearfix {
  border: 0 !important;
}

.download-top-section ul {
  list-style: none;
}
.download-top-section ul li {
  display: inline-block;
  vertical-align: middle;
  padding-left: 10px;
}
@media only screen and (max-width: 767px) {
  .download-top-section ul li {
    padding-left: 0;
    width: 100%;
  }
}
.download-top-section ul li:first-child {
  padding-left: 0;
}

.foursight-group h3 {
  text-align: left;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 400;
}
.foursight-group .date-section ul {
  max-width: 130px;
}

.print-section {
  margin-bottom: 10px;
}

.manage-profile-txt {
  margin: auto;
  float: none;
  padding-top: 30px;
}

.graph-loader {
  display: none;
}

::ng-deep .for-teams-view {
  box-shadow: none !important;
  padding: 0;
}

.indiv-graph > div {
  flex-wrap: nowrap;
}
.indiv-graph .team-graph__indiv {
  width: 12%;
  position: relative;
}
.indiv-graph .team-graph__indiv > div {
  text-align: right;
  font-size: clamp(13px, 1vw, 18px);
  line-height: 1;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 20px;
}
@media only screen and (max-width: 767px) {
  .indiv-graph .team-graph__indiv > div {
    right: 3px;
    font-size: 11px;
  }
}
.indiv-graph .team-graph__indiv > div:nth-child(1) {
  top: 10%;
}
@media only screen and (max-width: 1600px) {
  .indiv-graph .team-graph__indiv > div:nth-child(1) {
    top: 11%;
  }
}
.indiv-graph .team-graph__indiv > div:nth-child(2) {
  top: 44%;
}
@media only screen and (max-width: 1600px) {
  .indiv-graph .team-graph__indiv > div:nth-child(2) {
    top: 45%;
  }
}
.indiv-graph .team-graph__indiv > div:nth-child(3) {
  top: 86%;
}
@media only screen and (max-width: 1600px) {
  .indiv-graph .team-graph__indiv > div:nth-child(3) {
    top: 87%;
  }
}
.indiv-graph .team-graph__indiv > div:nth-child(4) {
  top: 102%;
}
@media only screen and (max-width: 1600px) {
  .indiv-graph .team-graph__indiv > div:nth-child(4) {
    top: 103%;
  }
}
.indiv-graph .team-graph__indiv > div span {
  font-size: 0.7em;
  font-weight: 400;
  display: block;
  padding-top: 4px;
}
.indiv-graph .team-graph__indiv > div {
  margin-left: auto;
}
.indiv-graph .chart-container {
  max-width: none !important;
  flex: 1;
}
.indiv-graph .for-teams-view {
  display: flex;
  flex-wrap: nowrap;
}
.indiv-graph .group-profile {
  width: 100%;
}
.indiv-graph .group-profile .main-group-profile {
  width: 100%;
  top: 0;
}
.indiv-graph .group-profile .main-group-profile .common-profile {
  margin-left: 0;
  margin-right: 0;
  width: 22% !important;
}
.indiv-graph .group-profile .main-group-profile .common-profile--hyt > * {
  top: 74px !important;
}
.indiv-graph .group-profile .main-group-profile .profile-flex-bottom {
  display: flex;
  justify-content: space-between;
  padding-inline: 20px;
}
@media only screen and (max-width: 767px) {
  .indiv-graph .group-profile .main-group-profile .profile-flex-bottom {
    padding-inline: 10px;
  }
}
.indiv-graph .profile-flex-top {
  position: absolute;
  width: 100%;
  top: 50px;
  display: flex;
  justify-content: space-between;
  padding-inline: 20px;
  grid-column-gap: 10px;
}
@media only screen and (max-width: 767px) {
  .indiv-graph .profile-flex-top {
    padding-inline: 10px;
  }
}
.indiv-graph .bottom-labels {
  display: flex;
  justify-content: space-between;
  grid-column-gap: 10px;
  padding-inline: 20px;
  top: 1px;
}
@media only screen and (max-width: 767px) {
  .indiv-graph .bottom-labels {
    padding-inline: 10px;
  }
}
.indiv-graph .bottom-labels .common-label {
  float: none;
  margin: 0;
  width: 22%;
  padding: 0;
  font-weight: 600;
  height: auto;
  line-height: 1;
}
.indiv-graph .bottom-labels .common-label::before {
  display: none;
}
.indiv-graph .bottom-labels .common-label div {
  --topClip: 12px;
  --labelPad: 8px;
  min-width: auto !important;
  max-width: none !important;
  padding-top: calc(var(--topClip) + var(--labelPad));
  clip-path: polygon(0 var(--topClip), 50% 0, 100% var(--topClip), 100% 100%, 0 100%);
  padding-bottom: var(--labelPad);
}
@media only screen and (max-width: 1600px) {
  .indiv-graph .bottom-labels .common-label {
    font-size: 10px;
  }
}
.indiv-graph .bottom-labels .common-label::before {
  border: 0;
  width: 100%;
  height: 12px;
  box-sizing: border-box;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
  top: auto;
  bottom: 99%;
}
.indiv-graph .bottom-labels .clarify-label::before {
  background-color: rgb(0, 173, 208);
}
.indiv-graph .bottom-labels .ideate-label::before {
  background-color: rgb(255, 121, 0);
}
.indiv-graph .bottom-labels .develop-label::before {
  background-color: rgb(105, 190, 40);
}
.indiv-graph .bottom-labels .implement-label::before {
  background-color: rgb(245, 67, 89);
}

.flx-nowrap {
  flex-wrap: nowrap;
}

.rstr_grph {
  flex-wrap: nowrap;
}
.rstr_grph__left {
  width: 12%;
  position: relative;
}
.rstr_grph__left > div {
  text-align: right;
  font-size: clamp(13px, 1vw, 18px);
  line-height: 1;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 20px;
}
.rstr_grph__left > div span {
  font-size: 0.7em;
  font-weight: 400;
  display: block;
  padding-top: 4px;
}
.rstr_grph__left > div:nth-child(1) {
  top: 11%;
}
.rstr_grph__left > div:nth-child(2) {
  top: 45%;
}
.rstr_grph__left > div:nth-child(3) {
  top: 89%;
}
.rstr_grph__right .bottom-labels {
  margin-top: 1px;
}

.for-teams-view--mwd {
  max-width: 740px;
}

.btn--nobdr {
  border: 0;
}

.neutrl {
  display: flex;
  justify-content: space-around;
}
.neutrl h4 {
  color: #676a6c;
}

.group-profile .inner-group-profile {
  border-bottom: 1px solid #d9d9d9;
  border-radius: 2px;
}
.group-profile .main-group-profile {
  top: 50px;
}
.group-profile .main-group-profile .integrators-region {
  background-color: #f1f1f2 !important;
  width: 100% !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.group-profile .main-group-profile .integrators-region > div {
  width: 15%;
  padding-left: 0 !important;
  margin-inline: 2.5%;
  text-align: center;
}
.group-profile .main-group-profile .integrators-region > div:first-child {
  width: calc(50px + 5%);
  margin: 0;
}
@media (max-width: 480px) {
  .group-profile .main-group-profile .integrators-region > div:first-child {
    width: 48px;
    padding: 0 5px !important;
    margin: 0;
  }
}
.group-profile .main-group-profile .integrators-region > div h4 {
  line-height: 1;
  margin-inline: 0;
}
.group-profile .main-group-profile .integrators-region > div h5 {
  font-size: 8px;
  font-weight: 500;
  color: #676A6C;
  margin: 4px 0 0;
  padding-left: 0;
}
.group-profile .main-group-profile .integrators-region > div:not(:first-child) {
  padding-left: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #676A6C;
}

@media screen and (max-width: 480px) {
  ::ng-deep .userProfile {
    padding-inline: 5px;
  }
}

@media screen and (max-width: 480px) {
  ::ng-deep .userProfile__graph .top-profile-txt .top-label-scores {
    font-size: 8px;
  }
}
::ng-deep .userProfile__graph .group-profile .inner-group-profile {
  border-color: #e7eaec !important;
  border-radius: 0 0 5px 5px !important;
}
::ng-deep .userProfile__graph .integrators-region h4 {
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  padding-inline: 12px;
}
::ng-deep .userProfile__graph .top-label-scores {
  bottom: 6px !important;
  font-size: 12px;
  font-weight: 600;
  text-shadow: none !important;
}
::ng-deep .userProfile__graph .top-label-scores__shd {
  position: absolute;
  width: 100%;
  bottom: 6px !important;
  font-size: 12px;
  font-weight: 600;
  text-shadow: 0px 0px 3px #000 !important;
}

::ng-deep .team-graph .team-profile-container {
  max-width: none !important;
}
::ng-deep .team-graph .group-profile .inner-group-profile {
  border-color: #e7eaec !important;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-profile {
  width: 15% !important;
  text-align: center;
}
@media screen and (min-width: 441px) {
  ::ng-deep .team-graph .group-profile .main-group-profile .common-profile.f-w-profile {
    width: 50px !important;
  }
}
::ng-deep .team-graph .group-profile .main-group-profile .common-profile._bg_changer_trns {
  background-color: transparent !important;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-profile._bg_changer_trns h5 {
  color: #676a6c !important;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-label {
  max-width: 50px;
  min-height: 175px;
  margin-top: 22px;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-label h5 {
  top: -10px;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-low.common-label {
  box-shadow: none !important;
  min-height: 180px;
  position: relative;
}
::ng-deep .team-graph .group-profile .main-group-profile .common-low.common-label h5 {
  bottom: 20px;
  position: absolute;
  top: unset;
  text-shadow: none !important;
  left: 50%;
  transform: translateX(-50%);
}
::ng-deep .team-graph .integrators-region > div {
  width: 15% !important;
}
::ng-deep .team-graph .integrators-region > div:not(:first-child) h5 {
  font-size: inherit !important;
}
::ng-deep .team-graph .integrators-region .main-group-profile.integrators-region__inner {
  width: 100% !important;
  padding-left: 0 !important;
}
::ng-deep .team-graph .integrators-region .main-group-profile.integrators-region__inner .integrators-region__center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
::ng-deep .team-graph .integrators-region .main-group-profile.integrators-region__inner .top-label-scores:not(.integrator-txt) {
  bottom: auto !important;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600 !important;
  font-size: 12px !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
::ng-deep .team-graph .integrators-region .main-group-profile.integrators-region__inner .integrator-txt {
  text-shadow: none !important;
  display: flex;
}
::ng-deep .team-graph .integrators-region .main-group-profile.integrators-region__inner .integrator-txt span {
  padding-left: 5px;
}
::ng-deep .team-graph .integrators-region h4 {
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  padding-inline: 0;
}

::ng-deep .fs-profile .wrapper-content--pd-0 {
  padding: 0;
}

.common {
  top: -50px !important;
}
.common-profile {
  background-color: transparent !important;
}
.common-profile--hyt {
  height: 50px !important;
}
.common-profile--hyt h5 {
  color: #676a6c !important;
}

.profile-top-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 50px;
  border-bottom: 1px solid #ccc;
}
.profile-top-list > .col {
  width: 20%;
  padding-left: 15px;
  font-size: 12px;
  font-weight: 600;
  color: #676A6C;
  line-height: 1;
}
@media (max-width: 1300px) {
  .profile-top-list > .col {
    width: 20%;
  }
}
@media (max-width: 1199px) {
  .profile-top-list > .col {
    padding-inline: 5px !important;
    word-wrap: break-word;
    text-wrap: balance;
  }
}

.f-p-left-13 {
  padding-left: 13px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/teams/individual-graph/individual-graph.component.scss","webpack://./src/app/components/team-profile/team-profile.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;AC9xBA;EACE,WAAA;ADiyBF;;AC9xBA;EACE,WAAA;ADiyBF;;AC9xBA;EACE,kBAAA;ADiyBF;;AC9xBA;EACE,qBAAA;ADiyBF;;AC9xBA;EACE,gBAAA;EACA,kBAAA;ADiyBF;;AC9xBA;EACE,cAAA;EACA,iBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;ADiyBF;;AC9xBA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;ADiyBF;AC/xBE;EACE,sBAAA;EACA,mBAAA;ADiyBJ;AC/xBI;EACE,SAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;ADiyBN;AC/xBM;EACE,iBAAA;EACA,SAAA;ADiyBR;AC5xBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;AD8xBJ;AC5xBI;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBFrBc;EEsBd,aAAA;EACA,WAAA;EACA,iBAAA;AD8xBN;AC3xBI;EACE,6CAAA;AD6xBN;AC1xBI;EACE,6CAAA;AD4xBN;ACzxBI;EACE,6CAAA;AD2xBN;ACxxBI;EACE,6CAAA;AD0xBN;ACvxBI;EACE,8CAAA;ADyxBN;ACtxBI;EACE,8CAAA;ADwxBN;ACrxBI;EACE,6CAAA;ADuxBN;ACpxBI;EACE,6CAAA;ADsxBN;ACnxBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ADqxBN;AClxBM;EACE,kBAAA;ADoxBR;AClxBQ;EACE,kBAAA;EACA,WAAA;EACA,WAAA;ADoxBV;ACjxBQ;EACE,WF9CS;EE+CT,6BAAA;ADmxBV;AC/wBM;EACE,4BAAA;EACA,2BAAA;ADixBR;AC7wBI;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AD+wBN;AC7wBM;EACE,kBAAA;AD+wBR;AC7wBQ;EACE,WFnES;EEoET,gBAAA;EACA,6BAAA;AD+wBV;AC3wBM;EAKE,+BAAA;EACA,8BAAA;ADywBR;ACrwBI;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,WFzFa;ACg2BnB;ACrwBM;EACE,iBAAA;EACA,gBAAA;ADuwBR;AClwBE;EACE,kBAAA;EACA,gBAAA;ADowBJ;AC1vBI;EACE,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WFpHa;EEqHb,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AD4vBN;AC1vBM;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,mFAAA;EACA,iBAAA;AD4vBR;AC1vBQ;EACE,aAAA;AD4vBV;ACzvBQ;EACE;IACE,eAAA;IACA,eAAA;ED2vBV;ECxvBQ;IACE,kBAAA;IACA,kBAAA;ED0vBV;AACF;ACvvBQ;EAzBF;IA0BI,eAAA;IACA,eAAA;IACA,eAAA;ED0vBR;AACF;ACxvBQ;EA/BF;IAgCI,eAAA;IACA,eAAA;ED2vBR;ECzvBQ;IACE,cAAA;ED2vBV;ECzvBU;IACE,aAAA;ED2vBZ;AACF;AC9sBI;EACE,6CAAA;ADgtBN;AC7sBI;EACE,0CAAA;AD+sBN;AC5sBI;EACE,6CAAA;AD8sBN;AC3sBI;EACE,0CAAA;AD6sBN;AC1sBI;EACE,8CAAA;AD4sBN;ACzsBI;EACE,2CAAA;AD2sBN;ACxsBI;EACE,6CAAA;AD0sBN;ACvsBI;EACE,0CAAA;ADysBN;;ACjsBI;;EAEE,SAAA;ADosBN;AChsBM;EACE,mBFpSW;EEqSX,iBAAA;ADksBR;AC/rBM;EACE,uCAAA;ADisBR;AC9rBM;EACE,0BAAA;ADgsBR;AC5rBI;EACE,0BAAA;EACA,2BAAA;AD8rBN;AC3rBQ;EACE,gBAAA;AD6rBV;AC1rBQ;EACE,YAAA;AD4rBV;ACxrBM;EACE,uCAAA;EACA,wCAAA;AD0rBR;ACvrBM;EACE,oBAAA;ADyrBR;ACrrBI;EACE,0BAAA;EACA,2BAAA;ADurBN;ACrrBM;EACE,uCAAA;EACA,wCAAA;ADurBR;ACprBM;EACE,oBAAA;ADsrBR;;AC/qBE;EACE,gBAAA;ADkrBJ;AChrBI;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;ADkrBN;AChrBM;EALF;IAMI,eAAA;IACA,WAAA;EDmrBN;AACF;ACjrBM;EACE,eAAA;ADmrBR;;AC5qBE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AD+qBJ;AC3qBI;EACE,gBAAA;AD6qBN;;ACxqBA;EACE,mBAAA;AD2qBF;;ACxqBA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AD2qBF;;ACxqBA;EACE,aAAA;AD2qBF;;ACxqBA;EACE,2BAAA;EACA,UAAA;AD2qBF;;ACtqBE;EACE,iBAAA;ADyqBJ;ACtqBE;EACE,UAAA;EACA,kBAAA;ADwqBJ;ACrpBI;EACE,iBAAA;EACA,iCAAA;EACA,cAAA;EACA,gBAAA;EAEA,kBAAA;EACA,MAAA;EACA,WAAA;ADspBN;ACppBM;EAVF;IAWI,UAAA;IACA,eAAA;EDupBN;AACF;ACrpBM;EACE,QAAA;ADupBR;ACrpBQ;EAHF;IAII,QAAA;EDwpBR;AACF;ACrpBM;EACE,QAAA;ADupBR;ACrpBQ;EAHF;IAII,QAAA;EDwpBR;AACF;ACrpBM;EACE,QAAA;ADupBR;ACrpBQ;EAHF;IAII,QAAA;EDwpBR;AACF;ACrpBM;EACE,SAAA;ADupBR;ACrpBQ;EAHF;IAII,SAAA;EDwpBR;AACF;ACppBM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ADspBR;AClpBI;EACE,iBAAA;ADopBN;AChpBE;EACE,0BAAA;EACA,OAAA;ADkpBJ;AC/oBE;EACE,aAAA;EACA,iBAAA;ADipBJ;AC9oBE;EACE,WAAA;ADgpBJ;AC9oBI;EACE,WAAA;EACA,MAAA;ADgpBN;AC9oBM;EACE,cAAA;EACA,eAAA;EACA,qBAAA;ADgpBR;AC5oBU;EACE,oBAAA;AD8oBZ;ACzoBM;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AD2oBR;ACzoBQ;EALF;IAMI,oBAAA;ED4oBR;AACF;ACvoBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;ADyoBJ;ACvoBI;EATF;IAUI,oBAAA;ED0oBJ;AACF;ACvoBE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,oBAAA;EACA,QAAA;ADyoBJ;ACvoBI;EAPF;IAQI,oBAAA;ED0oBJ;AACF;ACxoBI;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AD0oBN;ACxoBM;EACE,aAAA;AD0oBR;ACvoBM;EACE,eAAA;EACA,eAAA;EACI,0BAAA;EACA,0BAAA;EACA,mDAAA;EACA,mFAAA;EACA,+BAAA;ADyoBZ;ACtoBM;EAvBF;IAwBI,eAAA;EDyoBN;AACF;ACvoBM;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4CAAA;EACA,SAAA;EACA,WAAA;ADyoBR;ACroBM;EACE,kCF5lBQ;ACmuChB;ACnoBM;EACE,kCFhmBO;ACquCf;ACjoBM;EACE,mCFpmBQ;ACuuChB;AC/nBM;EACE,kCFxmBU;ACyuClB;;ACxnBA;EACE,iBAAA;AD2nBF;;ACxnBA;EACE,iBAAA;AD2nBF;ACznBE;EACE,UAAA;EACA,kBAAA;AD2nBJ;ACznBI;EACE,iBAAA;EACA,iCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AD2nBN;ACznBM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AD2nBR;ACxnBM;EACE,QAAA;AD0nBR;ACxnBM;EACE,QAAA;AD0nBR;ACxnBM;EACE,QAAA;AD0nBR;ACnnBI;EACE,eAAA;ADqnBN;;AC9mBE;EACE,gBAAA;ADinBJ;;AC7mBA;EACE,SAAA;ADgnBF;;AC7mBA;EACE,aAAA;EACA,6BAAA;ADgnBF;AC9mBE;EACE,cFrqBiB;ACqxCrB;;AAnzCI;EACI,gCAAA;EACA,kBAAA;AAszCR;AAnzCI;EACI,SAAA;AAqzCR;AAnzCQ;EACI,oCAAA;EAEA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAozCZ;AAlzCY;EAEI,UAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;AAmzChB;AA7yCgB;EACG,sBAAA;EAEC,SAAA;AA8yCpB;AA5yCoB;EALJ;IAMQ,WAAA;IACA,yBAAA;IACA,SAAA;EA+yCtB;AACF;AA3yCgB;EACI,cAAA;EACA,gBAAA;AA6yCpB;AA3yCgB;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA6yCpB;AAzyCY;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA2yChB;;AAlyCI;EADJ;IAEQ,mBAAA;EAsyCN;AACF;;AAnyCI;EAEQ;IACI,cAAA;EAqyCd;AACF;AAhyCQ;EACI,gCAAA;EACA,qCAAA;AAkyCZ;AA7xCQ;EACI,eAAA;EACA,gBAAA;EACA,cD5DS;EC6DT,oBAAA;AA+xCZ;AA3xCI;EACI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AA6xCR;AA3xCQ;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;AA6xCZ;;AAtxCI;EACI,0BAAA;AAyxCR;AApxCQ;EACI,gCAAA;AAsxCZ;AAhxCgB;EACI,qBAAA;EACA,kBAAA;AAkxCpB;AAjxCoB;EACI;IACI,sBAAA;EAmxC1B;AACF;AAjxCoB;EACI,wCAAA;AAmxCxB;AAlxCwB;EACI,yBAAA;AAoxC5B;AA/wCgB;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAixCpB;AA/wCoB;EACI,UAAA;AAixCxB;AA3wCgB;EACI,2BAAA;EACA,iBAAA;EACA,kBAAA;AA6wCpB;AA3wCoB;EACI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,SAAA;EACA,2BAAA;AA6wCxB;AAjwCQ;EACI,qBAAA;AAmwCZ;AAjwCgB;EACI,6BAAA;AAmwCpB;AA/vCQ;EACI,sBAAA;EACA,0BAAA;AAiwCZ;AAhwCY;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;AAkwChB;AAhwCY;EACI,uBAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;AAkwChB;AA/vCY;EACI,4BAAA;EACA,aAAA;AAiwChB;AAhwCgB;EACI,iBAAA;AAkwCpB;AA9vCQ;EACI,eAAA;EACA,gBAAA;EACA,cD1LS;EC2LT,iBAAA;AAgwCZ;;AAvvCQ;EACI,UAAA;AA0vCZ;;AAlvCA;EACI,qBAAA;AAqvCJ;AAnvCI;EACI,wCAAA;AAqvCR;AAnvCQ;EACI,uBAAA;AAqvCZ;AAnvCY;EACI,yBAAA;AAqvChB;;AA/uCA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;AAkvCJ;AAhvCI;EACI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAkvCR;AAhvCQ;EARJ;IASQ,UAAA;EAmvCV;AACF;AAjvCQ;EAZJ;IAaQ,8BAAA;IACA,qBAAA;IACA,kBAAA;EAovCV;AACF;;AA3uCA;EACI,6BAAA;AA8uCJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n@import './../../team-profile/team-profile.component.scss';\n\n\n.group-profile {\n\n    .inner-group-profile {\n        border-bottom: 1px solid $color-light-grey;\n        border-radius: 2px;\n    }\n \n    .main-group-profile {\n        top: 50px;\n\n        .integrators-region {\n            background-color: $color-neutral-light !important;\n            // width: 5% !important;\n            width: 100% !important;\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            & > div{\n                // width: calc(100% / 5);\n                width: 15%;\n                padding-left: 0 !important;\n                margin-inline: 2.5%;\n                text-align: center;\n\n                @media (max-width: 480px){\n\n                }\n\n                &:first-child{\n                   width: calc(50px + 5%);\n                    // padding-left: 20px !important;\n                    margin: 0;\n\n                    @media (max-width: 480px){\n                        width: 48px;\n                        padding: 0 5px !important;\n                        margin: 0;\n                    }\n\n                }\n\n                h4{\n                    line-height: 1;\n                    margin-inline: 0;\n                }\n                h5{\n                    font-size: 8px;\n                    font-weight: 500;\n                    color: #676A6C;\n                    margin: 4px 0 0;\n                    padding-left: 0;\n                }\n            }\n\n            & > div:not(:first-child){\n                padding-left: 7px;\n                font-size: 12px;\n                font-weight: 600;\n                color: #676A6C;\n            }\n\n        }\n\n    }\n    \n}\n::ng-deep .userProfile{\n    @media screen and (max-width: 480px){\n        padding-inline: 5px;\n    }\n}\n::ng-deep .userProfile__graph {\n    @media screen and (max-width: 480px){\n        .top-profile-txt{\n            .top-label-scores{\n                font-size: 8px;\n            }\n        }\n    }\n    .group-profile {\n\n        .inner-group-profile {\n            border-color: $color-grey-1 !important;\n            border-radius: 0 0 5px 5px !important;\n        }\n    }\n\n    .integrators-region {\n        h4 {\n            font-size: 12px;\n            font-weight: 600;\n            color: $body-content-color;\n            padding-inline: 12px;\n        }\n    }\n\n    .top-label-scores {\n        bottom: 6px !important;\n        font-size: 12px;\n        font-weight: 600;\n        text-shadow: none !important;\n\n        &__shd {\n            position: absolute;\n            width: 100%;\n            bottom: 6px !important;\n            font-size: 12px;\n            font-weight: 600;\n            text-shadow: 0px 0px 3px #000 !important;\n        }\n    }\n}\n\n::ng-deep .team-graph {\n\n    .team-profile-container {\n        max-width: none !important;\n    }\n\n    .group-profile {\n\n        .inner-group-profile {\n            border-color: $color-grey-1 !important;\n        }\n\n        .main-group-profile {\n            \n            .common {\n                &-profile {\n                    width: 15% !important;\n                    text-align: center;\n                    @media screen and (min-width: 441px){\n                        &.f-w-profile{\n                            width: 50px !important;\n                        }\n                    }\n                    &._bg_changer_trns {\n                        background-color: transparent !important;\n                        h5 {\n                            color: $body-content-color !important;\n                        }\n                    }\n                }\n\n                &-label {\n                    max-width: 50px;\n                    min-height: 175px;\n                    margin-top: 22px;\n\n                    h5 {\n                        top: -10px;\n                    }\n                }\n\n            &-low {\n\n                &.common-label {\n                    box-shadow: none !important;\n                    min-height: 180px;\n                    position: relative;\n\n                    h5 {\n                        bottom: 20px;\n                        position: absolute;\n                        top: unset;\n                        text-shadow: none !important;\n                        left: 50%;\n                        transform: translateX(-50%);\n                    }\n                }\n            }                \n\n            }\n        }\n\n    }\n\n    .integrators-region {\n        \n        & > div {\n            width: 15% !important;\n            &:not(:first-child) {\n                h5 {\n                    font-size: inherit !important;\n                }\n            }\n        }\n        .main-group-profile.integrators-region__inner{\n            width: 100% !important;\n            padding-left: 0 !important;\n            .integrators-region__center {\n                position: absolute;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n            .top-label-scores:not(.integrator-txt){\n                bottom: auto !important;\n                top: 50%;\n                transform: translateY(-50%);\n                font-weight: 600 !important;\n                font-size: 12px !important;\n                padding-bottom: 0 !important;\n                margin-bottom: 0 !important;\n                margin-top: 0 !important;\n             \n            }\n            .integrator-txt {\n                text-shadow: none !important;\n                display: flex;\n                span{\n                    padding-left: 5px;\n                }\n            }\n        }\n        h4 {\n            font-size: 12px;\n            font-weight: 600;\n            color: $body-content-color;\n            padding-inline: 0;\n        }\n    }\n}\n\n::ng-deep .fs-profile {\n\n    .wrapper-content {\n\n        &--pd-0 {\n            padding: 0;\n        }\n    }\n}\n\n// New Graph Style\n\n\n.common {\n    top: -50px !important;\n\n    &-profile {\n        background-color: transparent !important;\n        \n        &--hyt {\n            height: 50px!important;\n            \n            h5 {\n                color: $body-content-color !important;\n            }\n        }\n    }\n}\n\n.profile-top-list{\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    min-height: 50px;\n    border-bottom: 1px solid #ccc;\n\n    & > .col{\n        width: 20%;\n        padding-left: 15px;\n        font-size: 12px;\n        font-weight: 600;\n        color: #676A6C;\n        line-height: 1;\n\n        @media (max-width: 1300px){\n            width: 20%;\n        }\n\n        @media (max-width: 1199px){\n            padding-inline: 5px !important;\n            word-wrap: break-word;\n            text-wrap: balance;\n        }\n    }\n\n}\n// @media screen and (min-width: 1457px) {\n//     .f-m-left-50 {\n//         margin-left: 7%!important;\n//     }\n// }\n.f-p-left-13 {\n    padding-left: 13px !important;\n}\n","@import './../../../assets/styles/variables';\n\nh1 {\n  color: #888;\n}\n\n.clearfix {\n  clear: both;\n}\n\nh3 {\n  text-align: center;\n}\n\n.list ul li {\n  display: inline-block;\n}\n\n.list ul {\n  list-style: none;\n  text-align: center;\n}\n\n.report-users-list {\n  color: #6ABD45;\n  padding-left: 0px;\n  font-family: \"Conv_museo-500-webfont\";\n  font-size: 15px;\n  line-height: 1em;\n}\n\n.group-profile {\n  position: relative;\n  width: 100%;\n  flex: 1;\n\n  .inner-group-profile {\n    border: 1px solid $color-neutral-mid;\n    border-bottom: none;\n\n    .row {\n      margin: 0;\n      height: 50px;\n      border-bottom: 1px solid $color-neutral-mid;\n      padding: 0;\n\n      .text-center {\n        line-height: 50px;\n        margin: 0;\n      }\n    }\n  }\n\n  .main-group-profile {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 550px;\n    width: 100%;\n\n    .common-profile {\n      width: 20% !important;\n      margin-left: 2.5%;\n      margin-right: 2.5%;\n      background-color: $color-neutral-mid;\n      height: 100px;\n      float: left;\n      max-height: 200px;\n    }\n\n    .high-clarify {\n      background-color: $clarify-color !important;\n    }\n\n    .low-clarify {\n      background-color: $low-clarify-color !important;\n    }\n\n    .high-ideate {\n      background-color: $ideate-color !important;\n    }\n\n    .low-ideate {\n      background-color: $low-ideate-color !important;\n    }\n\n    .high-develop {\n      background-color: $develop-color !important;\n    }\n\n    .low-develop {\n      background-color: $low-develop-color !important;\n    }\n\n    .high-implement {\n      background-color: $implement-color !important;\n    }\n\n    .low-implement {\n      background-color: $low-implement-color !important;\n    }\n\n    .profile-flex-top {\n      position: absolute;\n      width: 100%;\n      top: 50px;\n      //margin-top: -50px;\n\n      .common-high {\n        position: relative;\n\n        .top-label-scores {\n          position: absolute;\n          bottom: 0px;\n          width: 100%;\n        }\n\n        h5 {\n          color: $color-light-type;\n          text-shadow: 0px 0px 3px #000;\n        }\n      }\n\n      .common-profile {\n        border-top-right-radius: 6px;\n        border-top-left-radius: 6px;\n      }\n    }\n\n    .profile-flex-bottom {\n      position: absolute;\n      top: 50%;\n      margin-top: 25px;\n      width: 100%;\n\n      .common-low {\n        margin-bottom: 1px;\n\n        h5 {\n          color: $color-light-type;\n          margin-top: 11px;\n          text-shadow: 0px 0px 3px #000;\n        }\n      }\n\n      .common-profile {\n        // box-shadow: inset 0px 0px 85px rgba(0, 0, 0, .3);\n        // -webkit-box-shadow: inset 0px 0px 85px rgba(0, 0, 0, .3);\n        // -moz-box-shadow: inset 0px 0px 85px rgba(0, 0, 0, .3);\n\n        border-bottom-right-radius: 6px;\n        border-bottom-left-radius: 6px;\n      }\n    }\n\n    .integrators-region {\n      position: relative;\n      height: 50px;\n      top: 50%;\n      margin-top: -25px;\n      background-color: $integrator-color !important;\n      color: $color-light-type;\n\n      h4 {\n        line-height: 50px;\n        margin: 0px 15px;\n      }\n    }\n  }\n\n  .bottom-labels {\n    position: relative;\n    margin-top: -2px;\n\n    // @media only screen and (min-width:769px) and (max-width:910px){\n    //   text-align: center;\n    // }\n\n    // @media only screen and (max-width:735px){\n    //   text-align: center;\n    // }\n\n    .common-label {\n      float: left;\n      width: 20%;\n      margin-left: 2.5%;\n      margin-right: 2.5%;\n      text-align: center;\n      color: $color-light-type;\n      position: relative;\n      text-transform: uppercase;\n      line-height: 30px;\n      height: 30px;\n      text-align: center;\n\n      div {\n        display: inline-block;\n        float: none;\n        width: 100%;\n        --topClip: 12px;\n        --labelPad: 8px;\n        clip-path: polygon(0 var(--topClip), 50% 0, 100% var(--topClip), 100% 100%, 0 100%);\n        padding-top: 20px;\n\n        .visible-xxs {\n          display: none;\n        }\n\n        @media only screen and (min-width:769px) and (max-width:910px) {\n          body.dash-admin-3 & {\n            min-width: 92px;\n            max-width: 92px;\n          }\n\n          body.mini-navbar & {\n            min-width: inherit;\n            max-width: inherit;\n          }\n        }\n\n        @media only screen and (max-width:735px) {\n          font-size: 13px;\n          min-width: 85px;\n          max-width: 85px;\n        }\n\n        @media only screen and (max-width:599px) {\n          min-width: 55px;\n          max-width: 55px;\n\n          .visible-xxs {\n            display: block;\n\n            +span {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n\n    // .common-label:before {\n    //   content: '';\n    //   width: 0;\n    //   height: 0;\n    //   border-left: 60px solid transparent;\n    //   border-right: 60px solid transparent;\n    //   /* border-bottom: 12px solid; */\n    //   display: block;\n    //   clear: both;\n    //   /* width: 100%; */\n    //   position: absolute;\n    //   top: -12px;\n    //   left: 0px;\n    //   right: 0px;\n    //   margin: 0 auto;\n\n    //   @media only screen and (min-width:769px) and (max-width:910px) {\n    //     body.dash-admin-3 & {\n    //       border-left: 46px solid transparent;\n    //       border-right: 46px solid transparent;\n    //     }\n\n    //     body.mini-navbar & {\n    //       border-left: 60px solid transparent;\n    //       border-right: 60px solid transparent;\n    //     }\n    //   }\n\n    //   @media only screen and (max-width:735px) {\n    //     border-left: 43px solid transparent;\n    //     border-right: 43px solid transparent;\n    //   }\n\n    //   @media only screen and (max-width:599px) {\n    //     border-left: 28px solid transparent;\n    //     border-right: 28px solid transparent;\n    //   }\n    // }\n\n    .clarify-block {\n      background-color: $clarify-color !important;\n    }\n\n    .clarify-label:before {\n      border-bottom: 12px solid $clarify-color;\n    }\n\n    .ideate-block {\n      background-color: $ideate-color !important;\n    }\n\n    .ideate-label:before {\n      border-bottom: 12px solid $ideate-color;\n    }\n\n    .develop-block {\n      background-color: $develop-color !important;\n    }\n\n    .develop-label:before {\n      border-bottom: 12px solid $develop-color;\n    }\n\n    .implement-block {\n      background-color: $implement-color !important;\n    }\n\n    .implement-label:before {\n      border-bottom: 12px solid $implement-color;\n    }\n  }\n}\n\n.participants {\n  .participant-content {\n\n    .col-md-2,\n    .col-md-1 {\n      border: 0;\n    }\n\n    .integrator-space {\n      &>div:first-child {\n        background: $integrator-color;\n        font-weight: bold;\n      }\n\n      &>div {\n        border-right: 1px solid $border-color !important;\n      }\n\n      &>div:last-child {\n        border-right: 0 !important;\n      }\n    }\n\n    .header-part {\n      border-top: 1px solid $border-color;\n      border-left: 1px solid $border-color;\n\n      >div:first-child {\n        h3 {\n          border-bottom: 0;\n        }\n\n        h3+div {\n          height: 100%;\n        }\n      }\n\n      &>div {\n        border-right: 1px solid $border-color !important;\n        border-bottom: 1px solid $border-color !important;\n      }\n\n      &>div.clearfix {\n        border: 0 !important;\n      }\n    }\n\n    .footer-part {\n      border-top: 1px solid $border-color;\n      border-left: 1px solid $border-color;\n\n      &>div {\n        border-right: 1px solid $border-color !important;\n        border-bottom: 1px solid $border-color !important;\n      }\n\n      &>div.clearfix {\n        border: 0 !important;\n      }\n    }\n  }\n}\n\n.download-top-section {\n  ul {\n    list-style: none;\n\n    li {\n      display: inline-block;\n      vertical-align: middle;\n      padding-left: 10px;\n\n      @media #{$mobile} {\n        padding-left: 0;\n        width: 100%;\n      }\n\n      &:first-child {\n        padding-left: 0;\n      }\n    }\n  }\n}\n\n.foursight-group {\n  h3 {\n    text-align: left;\n    margin-bottom: 0;\n    font-size: 13px;\n    font-weight: 400;\n  }\n\n  .date-section {\n    ul {\n      max-width: 130px;\n    }\n  }\n}\n\n.print-section {\n  margin-bottom: 10px;\n}\n\n.manage-profile-txt {\n  margin: auto;\n  float: none;\n  padding-top: 30px;\n}\n\n.graph-loader {\n  display: none;\n}\n\n::ng-deep .for-teams-view {\n  box-shadow: none !important;\n  padding: 0;\n}\n\n.indiv-graph {\n\n  & > div {\n    flex-wrap: nowrap;\n  }\n\n  .team-graph__indiv {\n    width: 12%;\n    position: relative;\n\n    // @media #{$mobile-up} {\n    //   width: 19%;\n    // }\n    // @media #{$tablet-up} {\n    //   width: 12%;\n    // }\n    // @media #{$pc-up} {\n    //   width: 13%;\n    // }\n    // @media #{$mobile} {\n    //   width: 13%;\n    // }\n    \n    // @media only screen and (max-width: 640px) {\n    //   width: 29%;\n    // }\n\n    & > div {\n      text-align: right;\n      font-size: clamp(13px, 1vw, 18px);\n      line-height: 1;\n      font-weight: 600;\n\n      position: absolute;\n      top: 0;\n      right: 20px;\n\n      @media #{$mobile} {\n        right: 3px;\n        font-size: 11px;\n      }\n\n      &:nth-child(1) {\n        top: 10%;\n        \n        @media #{$desktop} {\n          top: 11%;\n        }\n      }\n\n      &:nth-child(2) {\n        top: 44%;\n\n        @media #{$desktop} {\n          top: 45%;\n        }\n      }\n\n      &:nth-child(3) {\n        top: 86%;\n\n        @media #{$desktop} {\n          top: 87%;\n        }\n      }\n\n      &:nth-child(4) {\n        top: 102%;\n\n        @media #{$desktop} {\n          top: 103%;\n        }\n\n      }\n      \n      span {\n        font-size: 0.7em;\n        font-weight: 400;\n        display: block;\n        padding-top: 4px;\n      }\n    }\n\n    & > div {\n      margin-left: auto;\n    }\n  }\n\n  .chart-container {\n    max-width: none !important;\n    flex: 1;\n  }\n\n  .for-teams-view {\n    display: flex;\n    flex-wrap: nowrap;\n  }\n\n  .group-profile {\n    width: 100%;\n\n    .main-group-profile {\n      width: 100%;\n      top:0;\n      \n      .common-profile {\n        margin-left: 0;\n        margin-right: 0;\n        width: 22% !important;\n\n        &--hyt {\n\n          & > * {\n            top: 74px !important;;\n          }\n        }\n      }\n      \n      .profile-flex-bottom {\n        display: flex;\n        justify-content: space-between;\n        padding-inline: 20px;\n\n        @media #{$mobile} {\n          padding-inline: 10px;\n        }\n      }\n    }\n  }\n  \n  .profile-flex-top {\n    position: absolute;\n    width: 100%;\n    top: 50px;\n    display: flex;\n    justify-content: space-between;\n    padding-inline: 20px;\n    grid-column-gap: 10px;\n\n    @media #{$mobile} {\n      padding-inline: 10px;\n    }\n  }\n\n  .bottom-labels {\n    display: flex;\n    justify-content: space-between;\n    grid-column-gap: 10px;\n    padding-inline: 20px;\n    top: 1px;\n\n    @media #{$mobile} {\n      padding-inline: 10px;\n    }\n\n    .common-label {\n      float: none;\n      margin: 0;\n      width: 22%;\n      padding: 0;\n      font-weight: 600;\n      height: auto;\n      line-height: 1;\n\n      &::before {\n        display: none;\n      }\n\n      div {\n        --topClip: 12px;\n        --labelPad: 8px;\n            min-width: auto !important;\n            max-width: none !important;\n            padding-top: calc(var(--topClip) + var(--labelPad));\n            clip-path: polygon(0 var(--topClip), 50% 0, 100% var(--topClip), 100% 100%, 0 100%);\n            padding-bottom: var(--labelPad);\n        }\n\n      @media #{$desktop} {\n        font-size: 10px;\n      }\n\n      &::before {\n        border: 0;\n        width: 100%;\n        height: 12px;\n        box-sizing: border-box;\n        clip-path: polygon(50% 0, 100% 100%, 0 100%);\n        top: auto;\n        bottom: 99%;\n      }\n    }\n    .clarify-label {\n      &::before {\n        background-color: $clarify-color;\n      }\n    }\n    .ideate-label {\n      &::before {\n        background-color: $ideate-color;\n      }\n    }\n    .develop-label {\n      &::before {\n        background-color: $develop-color;\n      }\n    }\n    .implement-label {\n      &::before {\n        background-color: $implement-color;\n      }\n    }\n\n  }\n\n\n}\n\n.flx-nowrap {\n  flex-wrap: nowrap;\n}\n\n.rstr_grph {\n  flex-wrap: nowrap;\n\n  &__left {\n    width: 12%;\n    position: relative;\n\n    & > div{\n      text-align: right;\n      font-size: clamp(13px, 1vw, 18px);\n      line-height: 1;\n      font-weight: 600;\n      position: absolute;\n      top: 0;\n      right: 20px;\n\n      span {\n        font-size: 0.7em;\n        font-weight: 400;\n        display: block;\n        padding-top: 4px;\n      }\n    \n      &:nth-child(1) {\n        top: 11%;\n      }\n      &:nth-child(2) {\n        top: 45%;\n      }\n      &:nth-child(3) {\n        top: 89%;\n      }\n    }\n\n  }\n\n  &__right {\n    .bottom-labels {\n      margin-top: 1px;\n    }\n  }\n}\n\n.for-teams-view {\n\n  &--mwd {\n    max-width: 740px;\n  }\n}\n\n.btn--nobdr {\n  border: 0;\n}\n\n.neutrl {\n  display: flex;\n  justify-content: space-around;\n\n  h4 {\n    color: $body-content-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
